import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { AccordionCard } from '../../../components/Library/AccordionCard';
import { Card } from '../../../components/Library/Card';
import { AlgoOutput } from '../../../types';
import { colors } from '../../../utils/theme';

export const AlgoOutputs = (props: { output?: AlgoOutput }) => {
  const { output } = props;

  return (
    <Box padding={2}>
      <Card
        title={'Algo Outputs'}
        content={
          <Box columnGap={2} marginTop={2}>
            <Card
              title={'Nutrient Dosages'}
              content={
                <Grid container columnSpacing={2} paddingTop={2}>
                  {output?.recommendations?.map((result, index) => (
                    <Grid item xs={6} key={index}>
                      <Box sx={{ mb: 2 }}>
                        <AccordionCard
                          summary={
                            <Grid
                              container
                              item
                              flexDirection="row"
                              justifyContent={'space-between'}
                            >
                              <Typography fontSize={16}>
                                {result.name.toUpperCase()}
                              </Typography>
                              <Typography fontSize={16} paddingRight={4}>
                                {result.final_result}
                              </Typography>
                            </Grid>
                          }
                          details={<pre>{JSON.stringify(result, null, 2)}</pre>}
                          panelId={result.name.toUpperCase()}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              }
              cardStyles={{
                background: colors.greys.GREY_500,
                color: colors.greys.BRAND_BLACK,
              }}
            />
            <Card
              title={'DNA Category results'}
              content={
                <Grid container columnSpacing={2} paddingTop={2}>
                  {output?.dna_results?.map((result, index) => (
                    <Grid item xs={6} key={index}>
                      <Box sx={{ mb: 2 }}>
                        <AccordionCard
                          summary={
                            <Grid
                              container
                              item
                              flexDirection="row"
                              justifyContent={'space-between'}
                            >
                              <Typography fontSize={16}>
                                {result.name.toUpperCase()}
                              </Typography>
                              <Typography fontSize={16} pr={2}>
                                {result.result_text.toUpperCase()}
                              </Typography>
                            </Grid>
                          }
                          details={<pre>{JSON.stringify(result, null, 2)}</pre>}
                          panelId={result.name.toUpperCase()}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              }
              cardStyles={{
                background: colors.greys.GREY_500,
                color: colors.greys.BRAND_BLACK,
              }}
            />
          </Box>
        }
        cardStyles={{
          background: colors.greys.GREY_300,
          color: colors.greys.BRAND_BLACK,
        }}
      />
    </Box>
  );
};
